import { render } from "./WalletDashboard.vue?vue&type=template&id=d31e1258&scoped=true&ts=true"
import script from "./WalletDashboard.vue?vue&type=script&lang=ts"
export * from "./WalletDashboard.vue?vue&type=script&lang=ts"

import "./WalletDashboard.vue?vue&type=style&index=0&id=d31e1258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31e1258"]])

export default __exports__